import React from "react";
import { useState, useMemo, useCallback } from "react";
import { SPACING } from "@fedsim/constants";
import { Box, Alert, Grid } from "@mui/material";
import { NOOP } from '@fedsim/helpers'

import {
  GenericList,
  GenericCards,
  GenericAvatars,
  GenericCarousel
} from "./generic";
import { getCardComponent } from "./cards.js";
import { getListItemComponent } from "./items";
import { Paging } from "../paging";
import SearchHandler from "./search";
import TypeToggle from "./type";

import { HeaderSecondary, HeaderBody } from "../typography";
// import SortBy, { getSortByOptionsByGroupName } from './sortBy'

export * from "./tile";

function paginate(array, page_size = 12, page_number) {
  return array?.slice((page_number - 1) * page_size, page_number * page_size);
}

function search(array, searchTerm = "") {
  if (!searchTerm?.length) {
    return array;
  }
  return array?.filter((item) => {
    return item?.name?.toUpperCase()?.indexOf(searchTerm?.toUpperCase()) > -1;
  });
}

export function getListingComponent(listType) {
  switch (listType) {
    case "avatar":
      return GenericAvatars;
    case "card":
      return GenericCards;
    case "carousel":
      return GenericCarousel;
    default:
      return GenericList;
  }
}

function ListsUI({
  activeIndex = -1,
  onClick = NOOP,
  showNoItemsFound = true,
  defaultListType = "card",
  searchEnabled = true,
  // sortEnabled = false,
  toggleListType = true,
  perPage = 30,
  // defaultSortKey = 'name',
  // defaultSortDirection = 'asc',
  title = false,
  collection = [],
  actions = [],
  groupName = "Brand",
  PresentationItem = null
}) {
  const [listType, setListType] = useState(defaultListType);
  const [searchTerm, setSearchTerm] = useState("");
  // const [sortObj, setSortObj] = useState({
  //   sortKey: defaultSortKey,
  //   sortDirection: defaultSortDirection
  // })
  const [pageNumber, setPageNumber] = useState(1);
  // const sortOptions = useMemo(() => getSortByOptionsByGroupName(groupName), [groupName])
  const CardPresentationItem = useMemo(
    () => getCardComponent(groupName),
    [groupName]
  );
  const ListItemPresentationItem = useMemo(
    () => getListItemComponent(groupName),
    [groupName]
  );
  const showPaging = collection.length > perPage;

  // const onChangeSort = useCallback(
  //   (sortKey, sortDirection) => {
  //     setSortObj({ sortKey, sortDirection })
  //   },
  //   [setSortObj]
  // )
  // const sortFn = useCallback(() => {
  //   const sortBy = sortOptions?.find(item => item?.key === sortObj.sortKey && item?.direction === sortObj.sortDirection)?.fn

  //   return sortBy ? collection?.sort(sortBy) : collection
  // }, [collection, sortOptions, sortObj])
  const count = useMemo(
    () => Math.ceil(collection.length / perPage),
    [collection.length, perPage]
  );
  function getPresentationalComponent(listType) {
    return listType === "avatar" || listType === "carousel"
      ? null
      : listType === "card"
      ? CardPresentationItem
      : ListItemPresentationItem;
  }

  const PresentationComponent = getPresentationalComponent(listType, groupName);
  const ListingComponent = useMemo(
    () => getListingComponent(listType),
    [listType]
  );

  const activeCollection = useMemo(() => {
    const result = searchTerm
      ? search(collection, searchTerm)
      : paginate(collection, perPage, pageNumber);

    return result;
    // .sort(sortFn)
  }, [
    searchTerm,
    collection,
    perPage,
    pageNumber
    // sortFn
  ]);

  const onChangeToggle = useCallback(
    (event, value) => setListType(value),
    [setListType]
  );
  const onChangePagination = useCallback(
    (event, pageNumber) => setPageNumber(pageNumber),
    []
  );
  const onChangeSearchTerm = useCallback((term) => {
    setPageNumber(1);
    setSearchTerm(term);
  }, []);

  /*{searchTerm.length > 1 && (
    <Box>
      {searchTerm} ({activeCollection?.length} results)
    </Box>)}*/
  return (
    <>
      {title && <HeaderSecondary>{title}</HeaderSecondary>}
      {searchEnabled && collection.length > 1 && (
        <Box
          sx={{
            mb: SPACING / 2
          }}
        >
          <Grid container
            spacing={SPACING / 4}>
            <Grid item
              xs={8}
              sm={8}
              md={8}
              lg={8}>
              <SearchHandler
                onChange={onChangeSearchTerm}
                collection={collection}
              />
            </Grid>
            {toggleListType && (
              <Grid item
                xs={4}
                sm={4}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center"
                  }}
                >
                  <TypeToggle value={listType} onChange={onChangeToggle} />
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      )}
      {activeCollection.length > 0 ? (
        <ListingComponent
          activeIndex={activeIndex}
          onClick={onClick}
          PresentationItem={PresentationItem || PresentationComponent}
          collection={activeCollection}
          actions={actions}
        />
      ) : showNoItemsFound ? (
        <Alert severity="info">
          <HeaderBody>No items available</HeaderBody>
        </Alert>
      ) : null}
      {searchTerm.length === 0 && showPaging && (
        <Box mt={SPACING}>
          <Paging
            onChange={onChangePagination}
            pageNumber={pageNumber}
            siblingCount={1}
            count={count}
          />
        </Box>
      )}
    </>
  );
}

const Lists = React.memo(ListsUI);

export { GenericList, GenericCards, Lists };
export * from "./cards";

/*
{sortEnabled && (
  <Grid item xs={12} sm={12} md={8} lg={8}>
    <SortBy sortKey={sortObj.sortKey} sortDirection={sortObj.sortDirection} onChange={onChangeSort} sortOptions={sortOptions} />
  </Grid>
)}
*/
